import Seo, { orgSchema, breadcrumbSchema } from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { FadeUp, Eyebrow } from "@/components/Reveal";
import { Accordion } from "@/components/Accordion";
import { FAQ_GROUPS } from "@/data/content";

export default function Faq() {
    const allFaqs = FAQ_GROUPS.flatMap((g) => g.items);
    return (
        <>
            <Seo
                title="FAQ — Process, Budget, Coverage | Dagaz Development"
                description="Plain answers: how projects start, who builds, how budgets are set, financing, and coverage across all US states and Canadian provinces."
                path="/faq"
                jsonLd={[
                    orgSchema,
                    breadcrumbSchema([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]),
                    {
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        mainEntity: allFaqs.map((f) => ({
                            "@type": "Question",
                            name: f.q,
                            acceptedAnswer: { "@type": "Answer", text: f.a },
                        })),
                    },
                ]}
            />
            <PageHeader
                eyebrow="FAQ"
                titleLines={["Questions,", "answered plainly."]}
                answer="The questions every client asks before starting — how we work, who builds, what it costs and where we deliver. If yours is not here, write to damonson@dagazdesigns.com."
                crumbs={[{ name: "FAQ" }]}
            />
            <section className="px-6 md:px-12 lg:px-16 pb-28 md:pb-40 bg-chalk space-y-20" data-testid="faq-groups">
                {FAQ_GROUPS.map((g, gi) => (
                    <FadeUp key={g.group} delay={0.05 * gi}>
                        <div className="grid lg:grid-cols-12 gap-8">
                            <div className="lg:col-span-3">
                                <Eyebrow>{g.group}</Eyebrow>
                            </div>
                            <div className="lg:col-span-8 lg:col-start-5">
                                <Accordion items={g.items} testidPrefix={`faq-group-${gi}`} />
                            </div>
                        </div>
                    </FadeUp>
                ))}
            </section>
        </>
    );
}
